// @module BluePoint.SalesRepSection.SalesRepSection
define('BluePoint.SalesRepSection.SalesRepSection.View', [
    'bluepoint_salesrepsection_salesrepsection.tpl',
    'Profile.Model',
    'Backbone'
], function (
    bluepoint_salesrepsection_salesrepsection_tpl,
    ProfileModel,
    Backbone
) {
    'use strict';

    return Backbone.View.extend({

        template: bluepoint_salesrepsection_salesrepsection_tpl,

        initialize: function (options) {
            this.options = options || {};
            this.profile = ProfileModel.getInstance();
            this.salesRepInfo = options.salesRepInfo;

            console.log('Profile instance:', this.profile.toJSON());
        },

        getContext: function getContext() {
            var isLoggedIn = SC.ENVIRONMENT.siteSettings.is_logged_in;
            var customerLoggedIn = this.profile.get('isLoggedIn');
            var category = this.profile.get('category');
            var showSalesRepContent = false;

            console.log("customerLoggedIn", customerLoggedIn);
            console.log("isLoggedIn", isLoggedIn);
            console.log("category", category);

            if (customerLoggedIn == 'T' && this.salesRepInfo) {
                showSalesRepContent = true;
            }
            else if (showSalesRepContent == false) {
                var path = window.location.pathname;
                if(path === '/salesrep-information' ||
                   path === '/sales-information/sales-literature-to-order' ||
                   path === '/sales-information/items-not-available-for-customers' ||
                   path === '/iddsi-files'
                ) {
                    window.location.href = window.location.origin;
                }
            } 

            var origin = '';
            if (typeof window !== 'undefined' && window.location && window.location.origin) {
                origin = window.location.origin;
            }

            var salesInfoUrl = origin + '/salesrep-information';

            return {
                showSalesRepContent: showSalesRepContent,
                salesInfoUrl: salesInfoUrl
            };
        }
    });
});
